/* eslint-disable no-underscore-dangle */
import React from 'react';
import { RecoilRoot } from 'recoil';

import getInitialRecoilData from '../../utils/getInitialRecoilData';
import initialStateData from '../../state/initialStateData';

/**
 * We set a single recoil atom here with the entire initial state.
 * All other recoil atoms use selectors to derive their individual default values
 * from this single atom.
 * @param req
 */
const initializeState =
  (req) =>
  ({ set }) => {
    const initialRecoilState = getInitialRecoilData(req);
    set(initialStateData, initialRecoilState);
  };

const RecoilProvider = ({ children, req = {} }) => (
  <RecoilRoot initializeState={initializeState(req)}>{children}</RecoilRoot>
);

export default RecoilProvider;
